export default "__VITE_ASSET__7d2f9549__"